import { z } from 'zod';
import { DecimalJSLikeSchema } from "../inputTypeSchemas/DecimalJsLikeSchema"
import { isValidDecimalInput } from "../inputTypeSchemas/isValidDecimalInput"
import { CoreBillingTransactionServiceItemSchema } from '../inputTypeSchemas/CoreBillingTransactionServiceItemSchema'
import { CoreBillingTransactionStatusSchema } from '../inputTypeSchemas/CoreBillingTransactionStatusSchema'
import { CoreBillingTransactionTypeSchema } from '../inputTypeSchemas/CoreBillingTransactionTypeSchema'

/////////////////////////////////////////
// CORE BILLING TRANSACTION SCHEMA
/////////////////////////////////////////

export const CoreBillingTransactionSchema = z.object({
  serviceItem: CoreBillingTransactionServiceItemSchema.nullable(),
  status: CoreBillingTransactionStatusSchema,
  type: CoreBillingTransactionTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deactivatedAt: z.coerce.date().nullable(),
  amount: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'amount' must be a Decimal. Location: ['Models', 'CoreBillingTransaction']",  }),
  description: z.string(),
  transactionDate: z.coerce.date(),
  serviceDate: z.coerce.date(),
  quantity: z.number().int(),
  rate: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'rate' must be a Decimal. Location: ['Models', 'CoreBillingTransaction']",  }),
  referenceNumber: z.string().nullable(),
  accountId: z.number().int(),
})

export type CoreBillingTransaction = z.infer<typeof CoreBillingTransactionSchema>

export default CoreBillingTransactionSchema;
